import { render, staticRenderFns } from "./sobre.vue?vue&type=template&id=2040e128"
import script from "./sobre.vue?vue&type=script&lang=js"
export * from "./sobre.vue?vue&type=script&lang=js"
import style0 from "./sobre.vue?vue&type=style&index=0&id=2040e128&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports